import React from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import StudentDetail from "./StudentDetail";

const Dialogs = ({
  openDialog,
  handleDialogClose,
  newScholarship,
  confirmSwitchDialogOpen,
  setConfirmSwitchDialogOpen,
  proceedToNextScholarship,
  maxAwardsDialogOpen,
  setMaxAwardsDialogOpen,
  handleOverrideNomination,
  selectedScholarship,
  viewStudentModalOpen,
  setViewStudentModalOpen,
  viewStudent,
  toTitleCase,
  formatCurrency,
  isConfirmationOpen,
  setConfirmationOpen,
  handleConfirmUnassign,
  handleCancel,
}) => {
  return (
    <>
      {/* Scholarship Change Warning Dialog */}
      <Dialog
        open={openDialog}
        onClose={() => handleDialogClose(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle
          sx={{
            bgcolor: "primary.main",
            color: "white",
            textAlign: "center",
            fontWeight: "bold",
            mb: 2,
          }}
          id="alert-dialog-title"
        >
          {"Warning"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            There are selected students who have not been awarded. Do you want
            to continue? This will clear the selected students.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => handleDialogClose(false)} color="primary">
            Cancel
          </Button>
          <Button
            onClick={() => handleDialogClose(true)}
            color="primary"
            autoFocus
          >
            Continue
          </Button>
        </DialogActions>
      </Dialog>

      {/* Confirm Scholarship Switch Dialog */}
      <Dialog
        open={confirmSwitchDialogOpen}
        onClose={() => handleDialogClose(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle
          sx={{
            bgcolor: "primary.main",
            color: "white",
            textAlign: "center",
            fontWeight: "bold",
            mb: 2,
          }}
          id="alert-dialog-title"
        >
          {"Warning"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            There are selected students who have not been awarded. Do you want
            to continue? This will clear the selected students.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => setConfirmSwitchDialogOpen(false)}
            color="primary"
          >
            Cancel
          </Button>
          <Button
            onClick={() => {
              setConfirmSwitchDialogOpen(false);
              proceedToNextScholarship();
            }}
            color="primary"
            autoFocus
          >
            Continue
          </Button>
        </DialogActions>
      </Dialog>

<Dialog
  open={maxAwardsDialogOpen}
  onClose={() => setMaxAwardsDialogOpen(false)}
  aria-labelledby="max-awards-dialog-title"
  aria-describedby="max-awards-dialog-description"
>
  <DialogTitle
    sx={{
      bgcolor: "warning.main",
      color: "white",
      textAlign: "center",
      fontWeight: "bold",
      mb: 1,
    }}
    id="max-awards-dialog-title"
  >
    Award Limit Reached – Override?
  </DialogTitle>
  <DialogContent>
    <DialogContentText
      id="max-awards-dialog-description"
      sx={{ fontSize: 15, lineHeight: 1.6 }}
    >
      You have already selected the maximum number of awards for this scholarship
      (limit:{" "}
      <strong>{selectedScholarship?.number_of_awards || 0}</strong>).
      <br />
      <br />
      In some cases, more than the limit may be granted. Would you like to
      override and proceed with this nomination anyway?
    </DialogContentText>
  </DialogContent>
  <DialogActions>
    <Button
      onClick={() => setMaxAwardsDialogOpen(false)}
      color="primary"
      sx={{ fontWeight: 500 }}
    >
      Cancel
    </Button>
    <Button
      onClick={() => {
        handleOverrideNomination(); // Call your override logic
        setMaxAwardsDialogOpen(false);
      }}
      color="warning"
      variant="contained"
      sx={{ fontWeight: "bold" }}
    >
      Override
    </Button>
  </DialogActions>
</Dialog>
      {/* View Student Detail Modal */}
      <Dialog
        open={viewStudentModalOpen}
        onClose={() => setViewStudentModalOpen(false)}
        fullWidth
        maxWidth="md"
      >
        <DialogTitle
          sx={{
            bgcolor: "primary.main",
            color: "white",
            textAlign: "center",
            fontWeight: "bold",
            mb: 2,
          }}
        >
          {toTitleCase(viewStudent?.first_name)}{" "}
          {toTitleCase(viewStudent?.last_name)}
        </DialogTitle>
        <DialogContent>
          {viewStudent && (
            <StudentDetail
              activeStudent={viewStudent}
              selectedScholarship={selectedScholarship}
              formatCurrency={formatCurrency}
              toTitleCase={toTitleCase}
            />
          )}
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => setViewStudentModalOpen(false)}
            color="primary"
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>

      {/* Confirm Unassign Dialog */}
      <Dialog
        open={isConfirmationOpen}
        onClose={() => setConfirmationOpen(false)}
        fullWidth
        maxWidth="sm"
      >
        <DialogTitle
          sx={{
            bgcolor: "primary.main",
            color: "white",
            textAlign: "center",
            fontWeight: "bold",
            mb: 2,
          }}
        >
          Confirm Unassignment
        </DialogTitle>
        <DialogContent>
          <Typography variant="body1" sx={{ mb: 2, textAlign: "center" }}>
            Are you sure you want to unassign this award from the selected
            student?
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCancel} color="secondary" variant="outlined">
            Cancel
          </Button>
          <Button
            onClick={handleConfirmUnassign}
            color="primary"
            variant="contained"
            sx={{ width: "100px" }}
          >
            Confirm
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default Dialogs;
